import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import AssignmentTurnedInOutlinedIcon from 'components/material-symbol/icons/AssignmentTurnedIn'
import SearchIcon from 'components/material-symbol/icons/Search'
import RouterLinkButton from 'components/router-link-button'
import { TonalButton } from 'components/empty-page-state'
import { PGA_COM_HOST } from 'env'

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 720,
    margin: '0 auto',
    padding: theme.spacing(6, 2, 8),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 2, 6),
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
  },
  iconCircle: {
    alignItems: 'center',
    backgroundColor: '#C5A561',
    borderRadius: '50%',
    color: '#FFFFFF',
    display: 'flex',
    height: 80,
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    width: 80,
    '& .MuiSvgIcon-root': {
      fontSize: 40,
      color: '#FFFFFF',
    },
    '& svg': {
      fontSize: 40,
      width: 40,
      height: 40,
      color: '#FFFFFF',
    },
  },
  title: {
    fontSize: '1.75rem',
    lineHeight: 1.3,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  caption: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    maxWidth: 550,
  },
  captionSecondary: {
    marginTop: theme.spacing(0.5),
  },
  captionGroup: {
    marginBottom: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  textButton: {
    textTransform: 'none',
    fontWeight: 600,
    minHeight: 36,
    padding: theme.spacing(0.75, 1.5),
  },
}))

const Success = () => {
  const classes = useStyles()
  const { studentId } = useParams()

  return (
    <Container className={classes.container} maxWidth={false}>
      <Box className={classes.content}>
        <Box className={classes.iconCircle}>
          <AssignmentTurnedInOutlinedIcon />
        </Box>
        <Typography component="h1" className={classes.title}>
          Great job on updating your profile!
        </Typography>
        <Box className={classes.captionGroup}>
          <Typography variant="body2" className={classes.caption}>
            Your coach is now all set to give you an amazing lesson!
          </Typography>
          <Typography
            variant="body2"
            className={`${classes.caption} ${classes.captionSecondary}`}
          >
            Ready to discover exciting golf events near you?
          </Typography>
        </Box>
        <Box className={classes.actions}>
          <TonalButton
            component="a"
            href={`${PGA_COM_HOST}/things-to-do`}
            startIcon={<SearchIcon fontSize="small" />}
          >
            Find Programs
          </TonalButton>
          <RouterLinkButton
            variant="text"
            color="primary"
            to={`/account/students/${studentId}`}
            className={classes.textButton}
          >
            Go back
          </RouterLinkButton>
        </Box>
      </Box>
    </Container>
  )
}

export default Success
